"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.revokeIR = exports.getIRReducer = void 0;
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var usersList_1 = require("common/global/usersList");
var doesObjHaveUndefinedValues_1 = __importDefault(require("common/utils/doesObjHaveUndefinedValues"));
var removeUndefined_1 = __importDefault(require("common/utils/removeUndefined"));
var app_1 = __importDefault(require("firebase/app"));
var lodash_1 = require("lodash");
var set_1 = __importDefault(require("lodash/fp/set"));
var moment_1 = __importDefault(require("moment"));
var SendNotification_1 = require("portal/utils/SendNotification");
var sendApprovalNotification_1 = require("../../../utils/sendApprovalNotification");
var RFQReducer_1 = require("../RFQ/RFQReducer");
var ADD_ROW = "addRow";
var Approve = "Approve";
var Publish = "Publish";
var getIRReducer = function (t, router) { return function (state, action) {
    var _a, _b;
    var match = router.match;
    var irId = match.params.irId;
    var userId = (_b = (_a = app_1.default.auth().currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : "";
    // const publishedByUserId = userId ?? ''
    switch (action.type) {
        case "init":
            return action.payload;
        case "update":
            if (action.payload.path.endsWith("product")) {
                state = (0, set_1.default)(action.payload.path + "Id", action.payload.newValue.id, state);
                state = (0, set_1.default)(action.payload.path + "Name", action.payload.newValue.name, state);
                state = (0, set_1.default)(action.payload.path + "Description", action.payload.newValue.description, state);
                state = (0, set_1.default)(action.payload.path + "Type", action.payload.newValue.productType, state);
            }
            state.irItems.map(function (item, idx) {
                var _a, _b;
                if (action.payload.path === "irItems[".concat(idx, "].requiredDeliveryDate")) {
                    var isBefore = (0, moment_1.default)(action.payload.newValue).isBefore((_a = item.requiredDeliveryDate) === null || _a === void 0 ? void 0 : _a.toDate());
                    if (isBefore) {
                        antd_1.message.error("Required delivery date cannot be before IR date");
                    }
                    var newDate = isBefore
                        ? (_b = item.requiredDeliveryDate) === null || _b === void 0 ? void 0 : _b.toDate()
                        : action.payload.newValue;
                    return (0, set_1.default)(action.payload.path, newDate, state);
                }
            });
            return (0, set_1.default)(action.payload.path, action.payload.newValue, state);
        case "buttonClick": {
            var updatedState_1 = __assign({}, state);
            switch (action.data.action) {
                case ADD_ROW: {
                    var IRitem = newIrItem(irId);
                    collectionsRef_1.IRItemsRef.doc(IRitem.id).set(__assign({}, IRitem));
                    return __assign(__assign({}, state), { irItems: __spreadArray(__spreadArray([], state.irItems, true), [IRitem], false) });
                }
                case Approve: {
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    if (state.ref !== undefined &&
                                        action.data.payload.approvalType === "seniorLogisticOfficer" &&
                                        state.status === "pendingIrSeniorLogisticOfficerApproval") {
                                        transaction.update(collectionsRef_1.IRsRef.doc(irId), { ref: state.ref });
                                    }
                                    else if (state.ref === undefined &&
                                        action.data.payload.approvalType === "seniorLogisticOfficer" &&
                                        state.status === "pendingIrSeniorLogisticOfficerApproval") {
                                        antd_1.message.error(t("alerts.invalidFormMsg"));
                                        return [2 /*return*/, __assign(__assign({}, state), { triedSubmitting: true })];
                                    }
                                    console.log({ state: state });
                                    transaction.set(collectionsRef_1.approvalsRef.doc(), {
                                        approvedAt: action.data.payload.approvedAt,
                                        createdAt: new Date(),
                                        updatedAt: new Date(),
                                        userId: userId,
                                        formId: irId,
                                        formType: "internal-request",
                                        approvalType: action.data.payload.approvalType,
                                        signatureURL: (_b = (_a = usersList_1.globalUsersData[userId]) === null || _a === void 0 ? void 0 : _a.signatureURL) !== null && _b !== void 0 ? _b : "",
                                    });
                                    return [4 /*yield*/, checkIfAllApproved(irId, state.orderId, state, state.requestedBy, action.data.payload.approvalType, transaction)];
                                case 1:
                                    _c.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, antd_1.message.success(t("alerts.success"))];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    var nextStatus = checkNextStatus(state, action.data.payload.approvalType);
                    updatedState_1 = __assign(__assign({}, state), { status: nextStatus });
                    break;
                }
                case "Cancel": {
                    var isValid_1 = false;
                    collectionsRef_1.IRsRef.doc(irId)
                        .update({ status: "cancelled" })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0: return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                                        officeId: (_a = state.officeId) !== null && _a !== void 0 ? _a : "",
                                        projectId: state.projectId,
                                        docType: "internal-request",
                                        docId: irId,
                                        ref: (_b = state.ref) !== null && _b !== void 0 ? _b : "",
                                        docDesc: state.description,
                                        action: "cancelled",
                                    })];
                                case 1:
                                    _c.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    isValid_1 = true;
                                    return [4 /*yield*/, antd_1.message.success(t("alerts.success"))];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () { return window.location.reload(); });
                    updatedState_1 = isValid_1 ? __assign(__assign({}, state), { status: "cancelled" }) : state;
                    break;
                }
                case "Revoke": {
                    var isValid_2 = false;
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, (0, exports.revokeIR)(state, irId, state.orderId, transaction)];
                                case 1:
                                    if (_a.sent()) {
                                        isValid_2 = true;
                                    }
                                    else {
                                        isValid_2 = false;
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () {
                        if (isValid_2) {
                            antd_1.message.success(t("alerts.success"));
                            updatedState_1 = __assign(__assign({}, state), { status: "draft" });
                        }
                    })
                        .then(function () { return window.location.reload(); })
                        .catch(function () {
                        antd_1.message.error(t("alerts.error"));
                    });
                    break;
                }
                case Publish: {
                    var irData_1 = getIRFromState(state);
                    var uniqItemsTypes = (0, lodash_1.uniq)(state.irItems.map(function (irItem) { return irItem.productType; }));
                    if ((uniqItemsTypes.includes("asset") ||
                        uniqItemsTypes.includes("consumable")) &&
                        uniqItemsTypes.includes("service")) {
                        antd_1.message.error(t("alerts.cannotMixProductsAndServices"));
                        return __assign(__assign({}, state), { triedSubmitting: true });
                    }
                    if ((0, doesObjHaveUndefinedValues_1.default)(irData_1)) {
                        antd_1.message.error(t("alerts.invalidFormMsg"));
                        return __assign(__assign({}, state), { triedSubmitting: true });
                    }
                    state.irItems.map(function (item, index) {
                        var data = createIRItem(irId, item, state, index);
                        if ((0, doesObjHaveUndefinedValues_1.default)(data)) {
                            antd_1.message.error(t("alerts.invalidFormMsg"));
                            return __assign(__assign({}, state), { triedSubmitting: true });
                        }
                    });
                    var isValid_3 = true;
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (!!(0, doesObjHaveUndefinedValues_1.default)(irData_1)) return [3 /*break*/, 4];
                                    transaction.set(collectionsRef_1.IRsRef.doc(irId), (0, removeUndefined_1.default)(__assign({}, irData_1)), { merge: true });
                                    state.irItems.map(function (item, index) {
                                        var data = createIRItem(irId, item, state, index);
                                        if (!(0, doesObjHaveUndefinedValues_1.default)(data)) {
                                            transaction.set(collectionsRef_1.IRItemsRef.doc(item.id), __assign(__assign({}, data), { index: index }));
                                        }
                                        else {
                                            console.log("item is not valid", data);
                                            isValid_3 = false;
                                        }
                                    });
                                    if (!isValid_3) return [3 /*break*/, 2];
                                    console.log("valid");
                                    transaction.update(collectionsRef_1.IRsRef.doc(irId), {
                                        status: "pendingIrProjectManagerApproval",
                                        requestedAt: new Date(),
                                        requestedBy: app_1.default.auth().currentUser.uid,
                                    });
                                    return [4 /*yield*/, (0, sendApprovalNotification_1.sendApprovalNotification)({
                                            officeId: state.officeId,
                                            approval: "IRProjectManagerApproval",
                                            projectId: state.projectId,
                                            amount: state.totalEstimatedCostInUsd,
                                            docType: "internal-request",
                                            docId: irId,
                                            userId: userId,
                                            ref: (_a = state.ref) !== null && _a !== void 0 ? _a : "",
                                            docDesc: state.description,
                                            action: "approvalPending",
                                        })];
                                case 1:
                                    _b.sent();
                                    return [3 /*break*/, 3];
                                case 2:
                                    isValid_3 = false;
                                    _b.label = 3;
                                case 3: return [3 /*break*/, 5];
                                case 4:
                                    isValid_3 = false;
                                    _b.label = 5;
                                case 5: return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            if (isValid_3)
                                antd_1.message.success(t("alerts.success"));
                            return [2 /*return*/];
                        });
                    }); })
                        .then(function () {
                        if (isValid_3)
                            window.location.reload();
                    })
                        .catch(function (e) {
                        console.log(e);
                        console.error(e);
                        antd_1.message.error("alerts.error");
                    });
                    // return isValid
                    //   ? {
                    //       ...state,
                    //       status: "pendingIrProjectManagerApproval",
                    //       requestedAt: moment() as any,
                    //       requestedBy: firebase.auth().currentUser.uid,
                    //       triedSubmitting: true,
                    //     }
                    //   : {
                    //       ...state,
                    //       triedSubmitting: true,
                    //     };
                    //   updatedState = isValid
                    //     ? {
                    //         ...state,
                    //         status: "pendingIrProjectManagerApproval",
                    //         requestedAt: moment() as any,
                    //         requestedBy: firebase.auth().currentUser.uid,
                    //         triedSubmitting: true,
                    //       }
                    //     : {
                    //         ...state,
                    //         triedSubmitting: true,
                    //       };
                    break;
                }
                case "delete": {
                    var index_1 = action.data.payload;
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            transaction.delete(collectionsRef_1.IRItemsRef.doc((_a = state.irItems[index_1]) === null || _a === void 0 ? void 0 : _a.id));
                            return [2 /*return*/];
                        });
                    }); })
                        .then(function () {
                        antd_1.message.success(t("alerts.rowDeletedSuccessfully"));
                    });
                    updatedState_1 = __assign(__assign({}, state), { irItems: __spreadArray(__spreadArray([], state.irItems.slice(0, index_1), true), state.irItems.slice(index_1 + 1), true) });
                    break;
                }
                case "Save":
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        var newIRData, newIrItems;
                        return __generator(this, function (_a) {
                            transaction.set(collectionsRef_1.IRsRef.doc(irId), (0, removeUndefined_1.default)(getIRFromState(state)), { merge: true });
                            state.irItems.map(function (item, index) {
                                var data = createIRItem(irId, item, state, index);
                                transaction.update(collectionsRef_1.IRItemsRef.doc(item.id), (0, removeUndefined_1.default)(__assign({}, data)));
                            });
                            newIRData = (0, removeUndefined_1.default)(getIRFromState(state));
                            newIrItems = state.irItems.map(function (item, index) {
                                var data = createIRItem(irId, item, state, index);
                                return (0, removeUndefined_1.default)(__assign({}, data));
                            });
                            updatedState_1 = __assign(__assign(__assign(__assign(__assign({}, state), newIRData), { IRData: newIRData }), newIRData), { irItems: newIrItems });
                            return [2 /*return*/];
                        });
                    }); })
                        .then(function () {
                        antd_1.message.success(t("alerts.success"));
                    })
                        .catch(function (e) {
                        antd_1.message.error(e);
                    });
            }
            console.log({ updatedState: updatedState_1 });
            return updatedState_1;
        }
    }
}; };
exports.getIRReducer = getIRReducer;
var createIRItem = function (irId, iritem, state, index) {
    var _a, _b, _c, _d, _e, _f, _g;
    // console.log({iritem})
    return {
        IRId: irId,
        index: index,
        officeId: iritem.officeId,
        productId: iritem.productId,
        productName: iritem.productName,
        productType: iritem.productType,
        productDescription: iritem.productDescription,
        quantity: iritem.quantity,
        estimatedPrice: iritem.estimatedPrice,
        requiredDeliveryDate: (_b = (_a = iritem.requiredDeliveryDate) === null || _a === void 0 ? void 0 : _a.toDate()) !== null && _b !== void 0 ? _b : undefined,
        budgetLineId: (_c = iritem.budgetLineId) !== null && _c !== void 0 ? _c : "",
        budgetLinesIds: (_d = iritem.budgetLinesIds) !== null && _d !== void 0 ? _d : [],
        budgetLinesPercentages: (_e = iritem.budgetLinesPercentages) !== null && _e !== void 0 ? _e : [],
        unitId: (_g = (_f = iritem.product) === null || _f === void 0 ? void 0 : _f.unitId) !== null && _g !== void 0 ? _g : undefined,
        totalEstimatedPrice: iritem.quantity * iritem.estimatedPrice,
    };
};
function getIRFromState(state) {
    var _a, _b;
    var totalEstimatedCostInUsdMap = state.irItems.map(function (e) {
        var exRate = state.exchangeRate == 0 ? 1 : state.exchangeRate;
        return (e.quantity * e.estimatedPrice) / exRate;
    });
    var totalEstimatedCostInLocalCurrencyMap = state.irItems.map(function (e) {
        return e.estimatedPrice * e.quantity;
    });
    var totalEstimatedCostInUsd = (0, lodash_1.sumBy)(totalEstimatedCostInUsdMap);
    var totalEstimatedCostInLocalCurrency = (0, lodash_1.sumBy)(totalEstimatedCostInLocalCurrencyMap);
    return {
        orderId: state.orderId,
        status: state.status,
        projectId: state.projectId,
        projectsIds: state.projectsIds,
        officeId: (_a = state.officeId) !== null && _a !== void 0 ? _a : "",
        ref: state.ref,
        description: state.description,
        department: state.department,
        deliveryLocation: state.deliveryLocation,
        exchangeRate: state.exchangeRate,
        currencyId: state.currencyId,
        // budgetLineId: state.budgetLineId,
        IRDate: (_b = state.IRDate) === null || _b === void 0 ? void 0 : _b.toDate(),
        totalEstimatedCostInLocalCurrency: totalEstimatedCostInLocalCurrency,
        totalEstimatedCostInUsd: totalEstimatedCostInUsd,
    };
}
function newIrItem(irId) {
    return {
        id: collectionsRef_1.IRItemsRef.doc().id,
        IRId: irId,
        budgetLineId: "",
        // budgetLineItemId: "",
        budgetLinesIds: [],
        budgetLinesPercentages: [],
        estimatedPrice: 0,
        officeId: "",
        productId: "",
        quantity: 0,
        requiredDeliveryDate: null,
    };
}
function checkIfAllApproved(IRId, orderId, state, userId, approvalType, transaction) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var waitingFor, status;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!(approvalType === "projectManager")) return [3 /*break*/, 1];
                    waitingFor = "IRFinanceProjectManagerApproval";
                    transaction.update(collectionsRef_1.IRsRef.doc(IRId), {
                        status: "pendingIrFinanceProjectManagerApproval",
                    });
                    status = "pendingIrFinanceProjectManagerApproval";
                    return [3 /*break*/, 8];
                case 1:
                    if (!(approvalType === "generalDirector")) return [3 /*break*/, 2];
                    waitingFor = "IRSeniorLogisticOfficerApproval";
                    transaction.update(collectionsRef_1.IRsRef.doc(IRId), {
                        status: "pendingIrSeniorLogisticOfficerApproval",
                    });
                    status = "pendingIrSeniorLogisticOfficerApproval";
                    return [3 /*break*/, 8];
                case 2:
                    if (!(approvalType === "deputyGeneral" &&
                        state.totalEstimatedCostInUsd < 1000)) return [3 /*break*/, 3];
                    console.log("hereddd");
                    console.log(state.totalEstimatedCostInUsd);
                    waitingFor = "IRSeniorLogisticOfficerApproval";
                    transaction.update(collectionsRef_1.IRsRef.doc(IRId), {
                        status: "pendingIrSeniorLogisticOfficerApproval",
                    });
                    status = "pendingIrSeniorLogisticOfficerApproval";
                    return [3 /*break*/, 8];
                case 3:
                    if (!(approvalType === "financeProjectManager" &&
                        state.totalEstimatedCostInUsd > 100)) return [3 /*break*/, 4];
                    console.log(state.totalEstimatedCostInUsd);
                    waitingFor = "IRDeputyGeneralApproval";
                    transaction.update(collectionsRef_1.IRsRef.doc(IRId), {
                        status: "pendingIrDeputyGeneralApproval",
                    });
                    status = "pendingIrDeputyGeneralApproval";
                    return [3 /*break*/, 8];
                case 4:
                    if (!(approvalType === "financeProjectManager" &&
                        state.totalEstimatedCostInUsd <= 100)) return [3 /*break*/, 5];
                    waitingFor = "IRSeniorLogisticOfficerApproval";
                    transaction.update(collectionsRef_1.IRsRef.doc(IRId), {
                        status: "pendingIrSeniorLogisticOfficerApproval",
                    });
                    status = "pendingIrSeniorLogisticOfficerApproval";
                    return [3 /*break*/, 8];
                case 5:
                    if (!(approvalType === "seniorLogisticOfficer")) return [3 /*break*/, 7];
                    transaction.update(collectionsRef_1.IRsRef.doc(IRId), { status: "approved" });
                    transaction.update(collectionsRef_1.ordersRef.doc(orderId), {
                        status: "preparingRFQs",
                        projectsIds: state.projectsIds,
                    });
                    return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                            officeId: (_a = state.officeId) !== null && _a !== void 0 ? _a : "",
                            projectId: state.projectId,
                            docType: "internal-request",
                            docId: IRId,
                            ref: (_b = state.ref) !== null && _b !== void 0 ? _b : "",
                            docDesc: state.description,
                            action: "approved",
                        })];
                case 6:
                    _d.sent();
                    status = "approved";
                    return [2 /*return*/];
                case 7:
                    if (approvalType === "deputyGeneral" &&
                        state.totalEstimatedCostInUsd >= 1000
                    //   globalProjectsData[state.projectId]?.thresholdForRequiringIRFifthApproval
                    ) {
                        waitingFor = "IRGeneralDirectorApproval";
                        transaction.update(collectionsRef_1.IRsRef.doc(IRId), {
                            status: "pendingIrGeneralDirectorApproval",
                        });
                        status = "pendingIrGeneralDirectorApproval";
                    }
                    _d.label = 8;
                case 8: return [4 /*yield*/, (0, sendApprovalNotification_1.sendApprovalNotification)({
                        officeId: state.officeId,
                        approval: waitingFor !== null && waitingFor !== void 0 ? waitingFor : "approved",
                        projectId: state.projectId,
                        amount: state.totalEstimatedCostInUsd,
                        docType: "internal-request",
                        docId: IRId,
                        userId: state.requestedBy,
                        ref: (_c = state.ref) !== null && _c !== void 0 ? _c : "",
                        docDesc: state.description,
                        action: "approvalPending",
                    })];
                case 9:
                    _d.sent();
                    return [2 /*return*/, status];
            }
        });
    });
}
function checkNextStatus(state, approvalType) {
    var status;
    if (approvalType === "projectManager") {
        status = "pendingIrFinanceProjectManagerApproval";
    }
    else if (approvalType === "generalDirector") {
        status = "pendingIrSeniorLogisticOfficerApproval";
    }
    else if (approvalType === "deputyGeneral" &&
        state.totalEstimatedCostInUsd < 1000) {
        status = "pendingIrSeniorLogisticOfficerApproval";
    }
    else if (approvalType === "financeProjectManager" &&
        state.totalEstimatedCostInUsd > 100) {
        status = "pendingIrDeputyGeneralApproval";
    }
    else if (approvalType === "financeProjectManager" &&
        state.totalEstimatedCostInUsd <= 100) {
        status = "pendingIrSeniorLogisticOfficerApproval";
    }
    else if (approvalType === "seniorLogisticOfficer") {
        status = "approved";
    }
    else if (approvalType === "deputyGeneral" &&
        state.totalEstimatedCostInUsd >= 1000) {
        console.log("hereee");
        status = "pendingIrGeneralDirectorApproval";
    }
    return status;
}
var revokeIR = function (state, IRId, orderId, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var RFQs, someCompleted, itemsReceived;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0: return [4 /*yield*/, collectionsRef_1.RFQsRef.where("irId", "==", IRId).get()];
            case 1:
                RFQs = (_e.sent()).docs;
                someCompleted = RFQs.some(function (x) {
                    var data = x.data();
                    return data.status === "singedAndArchived" || data.status === "completed";
                });
                if (someCompleted) {
                    throw new Error("you cannot revoke singed form");
                }
                return [4 /*yield*/, collectionsRef_1.DNsRef.where("orderId", "==", orderId).get()];
            case 2:
                itemsReceived = (_e.sent())
                    .docs.length;
                if (itemsReceived) {
                    antd_1.message.error("This IR has Delivery Note and cannot be revoked");
                    return [2 /*return*/, false];
                }
                return [4 /*yield*/, Promise.all(RFQs.map(function (RFQId) { return (0, RFQReducer_1.deleteRFQ)(RFQId.id, orderId, transaction); }))];
            case 3:
                _e.sent();
                transaction.update(collectionsRef_1.IRsRef.doc(IRId), {
                    status: "draft",
                    requestedAt: (_a = app_1.default.firestore.FieldValue) === null || _a === void 0 ? void 0 : _a.delete(),
                    requestedBy: (_b = app_1.default.firestore.FieldValue) === null || _b === void 0 ? void 0 : _b.delete(),
                }), transaction.update(collectionsRef_1.ordersRef.doc(orderId), { status: "preparingIR" });
                return [4 /*yield*/, collectionsRef_1.approvalsRef.where("formId", "==", IRId).get()];
            case 4:
                (_e.sent()).docs.map(function (x) {
                    return transaction.delete(x.ref);
                });
                return [4 /*yield*/, collectionsRef_1.notificationsRef.where("docId", "==", IRId).get()];
            case 5:
                (_e.sent()).docs.map(function (x) {
                    return transaction.delete(x.ref);
                });
                return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                        officeId: (_c = state.officeId) !== null && _c !== void 0 ? _c : "",
                        projectId: state.projectId,
                        docType: "internal-request",
                        docId: IRId,
                        ref: (_d = state.ref) !== null && _d !== void 0 ? _d : "",
                        docDesc: state.description,
                        action: "revoked",
                    })];
            case 6:
                _e.sent();
                return [2 /*return*/, true];
        }
    });
}); };
exports.revokeIR = revokeIR;
// export const deleteIR = async (IRId: string, transaction?: firebase.firestore.Transaction) => {
//     const data = (await transaction.get(IRsRef.doc(IRId))).data()
//     if (data.status === 'completed') {
//         throw new Error(`you cannot delete completed RFQ`)
//     }
//     if (data.status === 'pendingApprovals' || data.status === 'approved') {
//         await revokeIR(IRId,orderId ,  transaction)
//     }
//     transaction.delete(IRsRef.doc(IRId))
//     await Promise.all((await IRItemsRef.where('IRId', '==', IRId).get()).docs.map(x => transaction.delete(x.ref)))
// }
